export type ChatMessageInputProps = {
  placeholder?: string;
  disabled?: boolean;
  transcribeStt?: (audioBlob: Blob) => Promise<string>;
  extractOcr?: (imageFile: File) => Promise<string>;
};

export const chatMessageInputDefaults: Partial<ChatMessageInputProps> = {
  disabled: false,
};
